import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-navbar',
  templateUrl: './navbar.component.html',
  styleUrls: ['./navbar.component.sass']
})
export class NavbarComponent implements OnInit {

  public innerWidth: any;
  public sidebarExpanded = true;

  constructor() { }

  ngOnInit(): void {
    if ( this.innerWidth < 1140) {
      this.sidebarExpanded = false;
      console.log("less", this.innerWidth);
    }
    else {
        /* Set the width of the side navigation to 250px and the left margin of the page content to 250px */
        console.log("more", this.innerWidth);
        this.sidebarExpanded = true;
      }
  }

  buttonOpenAndClose(){
    this.sidebarExpanded = !this.sidebarExpanded;
    console.log("cambiando el valor", this.sidebarExpanded);
  }
  

}
